import request from '@/providers/http-service'
const url1 = `${process.env.VUE_APP_API_DOMAIN}`
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`
// const url = `${process.env.VUE_APP_API_DOMAIN}`

// 删除单条数据
export function shanghuInfoDel(params) {
  return request({
    url: url + '/shanghu-info/del',
    method: 'get',
    params
  })
}

// 查询单条数据
export function shanghuInfoDetail(params) {
  return request({
    url: url + '/shanghu-info/detail',
    method: 'get',
    params
  })
}

// 新增修改单条数据
export function shanghuInfoEdit(params) {
  return request({
    url: url + '/shanghu-info/edit',
    method: 'post',
    data: params
  })
}

// 导入商户数据
export function shanghuInfoImport(params) {
  return request({
    url: url + '/shanghu-info/importShanghu',
    method: 'post',
    data: params
  })
}

// 商户分页查询
export function shanghuInfoPage(params) {
  return request({
    url: url + '/shanghu-info/shanghuPage',
    method: 'post',
    data: params
  })
}

// 商户审核和商户用户分页查询
export function userShanghuPage(params) {
  return request({
    url: url1 + '/tbase-iam-manage/user/shanghuPage',
    method: 'post',
    data: params
  })
}

// 导出商户数据
export function shanghuExp(params) {
  return request({
    url: url + '/shanghu-info/shanghuExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}


// WEBPACK FOOTER //
// ./src/api/shanghu.js